"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _hexToRgba = _interopRequireDefault(require("../../utils/hexToRgba"));
var _breakpoint = _interopRequireDefault(require("../../theming/breakpoint"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ComplementaryTheme = function ComplementaryTheme(baseTheme) {
  return {
    complementaryName: 'complementary-caixa-seguradora',
    complemetaryVersion: '1.0.0',
    border: {
      radius: {
        none: 'none',
        '3xs': '4px',
        '2xs': '8px',
        xs: '12px',
        sm: '16px',
        md: '24px',
        lg: '32px',
        xl: '44px',
        '2xl': '60px',
        '3xl': '80px',
        pill: '500px',
        circular: '50%'
      },
      width: {
        none: 'none',
        sm: '1px',
        md: '2px',
        lg: '4px',
        xl: '8px'
      }
    },
    divider: {
      horizontal: {
        sm: '1px',
        md: '2px',
        lg: '4px',
        xl: '8px'
      },
      vertical: {
        sm: '1px',
        md: '2px',
        lg: '4px',
        xl: '8px'
      }
    },
    opacity: {
      level: {
        darkest: '0.88',
        dark: '0.64',
        medium: '0.40',
        light: '0.24',
        lightest: '0.08'
      }
    },
    shadow: {
      level: {
        '01': "0px 4px 5px ".concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.08)),
        '02': "0px -2px 2px ".concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.05), ", 0px 6px 8px ").concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.16)),
        '03': "0px -2px 2px ".concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.05), ", 0px 8px 12px ").concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.16)),
        '04': "0px 10px 28px ".concat((0, _hexToRgba["default"])(baseTheme.color.neutral['01'], 0.2))
      }
    },
    icon: {
      size: {
        '3xs': '12px',
        '2xs': '16px',
        xs: '20px',
        sm: '24px',
        md: '28px',
        lg: '32px',
        xl: '36px',
        '2xl': '40px',
        '3xl': '44px',
        '4xl': '48px'
      }
    },
    spacing: {
      inset: {
        '4xs': '4px',
        '3xs': '8px',
        '2xs': '12px',
        xs: '16px',
        sm: '20px',
        md: '24px',
        lg: '32px',
        xl: '40px',
        '2xl': '60px',
        '3xl': '80px',
        '4xl': '100px'
      },
      squish: {
        xs: '4px 16px',
        sm: '8px 16px',
        md: '8px 24px',
        lg: '16px 36px',
        xl: '16px 48px'
      },
      squeeze: {
        xs: '20px 16px',
        sm: '24px 16px',
        md: '28px 16px',
        lg: '36px 16px',
        xl: '44px 16px'
      },
      stack: {
        '6xs': '4px',
        '5xs': '8px',
        '4xs': '12px',
        '3xs': '16px',
        '2xs': '20px',
        xs: '24px',
        sm: '32px',
        md: '40px',
        lg: '48px',
        xl: '56px',
        '2xl': '64px',
        '3xl': '80px',
        '4xl': '100px',
        '5xl': '120px',
        '6xl': '160px',
        '7xl': '200px'
      },
      inline: {
        '6xs': '4px',
        '5xs': '8px',
        '4xs': '12px',
        '3xs': '16px',
        '2xs': '20px',
        xs: '24px',
        sm: '28px',
        md: '32px',
        lg: '36px',
        xl: '40px',
        '2xl': '44px',
        '3xl': '48px',
        '4xl': '52px',
        '5xl': '56px',
        '6xl': '60px',
        '7xl': '64px'
      }
    },
    breakpoint: _breakpoint["default"]
  };
};
var _default = exports["default"] = ComplementaryTheme;